import {globals} from '@extensions/globals-base'
import {Connector} from './connector'

const noNetworkTimeout = 30_000

export class NetworkStatusClient {
  static loadedLocalTimestamp = Date.now()
  static lastReadyLocalTimestamp = 0
  static interval: ReturnType<typeof setTimeout>

  static init(): void {
    clearInterval(this.interval)
    this.interval = setInterval(() => {
      if (Connector.isReady()) {
        this.lastReadyLocalTimestamp = Date.now()
      }
    }, 1000)
  }

  static shouldShowNetworkWarning(): boolean {
    return (
      !globals.readonly &&
      !Connector.isReady() &&
      Date.now() - this.loadedLocalTimestamp > noNetworkTimeout &&
      Date.now() - this.lastReadyLocalTimestamp > noNetworkTimeout
    )
  }
}
